import gql from 'graphql-tag';
import { take, tap, pluck, withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
import * as i2 from "apollo-angular/Apollo";
// * QUERY FILTRO MAQUINA
const QUERY_clientes_registros = gql `
  query (
    $filtro: FiltroInputTypeOfmaquinaTOmaquinaInputType
    $estado: [Decimal]
    $familia: [Decimal]
    $vendedor: [Decimal]
    $proveedor: [Decimal]
    $rubro: [Decimal]
    $paginaActual: Int
    $cantidadRegistrosPorPagina: Int
  ) {
    maquina {
      obtenerSegunFiltroMaquina(
        filtro: $filtro
        estado: $estado
        familia: $familia
        vendedor: $vendedor
        proveedor: $proveedor
        rubro: $rubro
        paginaActual: $paginaActual
        cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
      ) {
        mensajes {
          codigo
          texto
          tipo
        }
        respuesta {
          paginaActual
          cantidadRegistrosPorPagina
          totalPaginas
          totalRegistros
          registros {
            empresa_rut
            numero_placa
            modelo
            nombre
            fecha_compra
            estado_maquina_nombre
            estado_maquina_codigo
            sucursal_codigo
            familia_maquina_codigo
            direccion
            nombre_comuna
            codigo_vendedor
            nombre_vendedor
            ubicacion
            nombre_cliente
            nombre_sucursal
            activo
            tipo_dte_codigo
            numero_documento
            cliente_proveedor_rut
            grupo_maquina_codigo
            observacion
            tipo_destinatario_codigo
            proveedor_rut
            proveedor_nombre
            cliente_proveedor_rut
            cerrado
            tipo_garantia_codigo
            nro_documento_garantia
            fecha_garantia
            numero_contrato
            fecha_contrato
            fecha_vigencia_contrato
            fecha_termino_contrato
            fecha_entrega
            codigo_rubro
          }
        }
      }
    }
  }
`;
export class MaquinaService {
    constructor(gqlclient, apollo) {
        this.gqlclient = gqlclient;
        this.apollo = apollo;
        this.clientesDataSubject = new BehaviorSubject(null);
        this.Clientess$ = this.clientesDataSubject.asObservable();
    }
    //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
    getMaquinaFiltro(inputParams) {
        this.postsQuery = this.apollo.watchQuery({
            query: QUERY_clientes_registros,
            variables: inputParams,
            fetchPolicy: 'network-only',
        });
        this.queryCliente = this.postsQuery.valueChanges.pipe(take(1), pluck('data', 'maquina'), withLatestFrom(this.Clientess$), tap(([apiResponse, respuesta]) => {
            return apiResponse.obtenerSegunFiltroMaquina.respuesta;
        }));
    }
    obtenerSegunFiltroMaquina(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $filtro: FiltroInputTypeOfmaquinaTOmaquinaInputType
            $estado: [Decimal]
            $familia: [Decimal]
            $vendedor: [Decimal]
            $proveedor: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            maquina {
              obtenerSegunFiltroMaquina(
                filtro: $filtro
                estado: $estado
                familia: $familia
                vendedor: $vendedor
                proveedor: $proveedor
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    numero_placa
                    modelo
                    nombre
                    fecha_compra
                    estado_maquina_nombre
                    estado_maquina_codigo
                    sucursal_codigo
                    familia_maquina_codigo
                    direccion
                    nombre_comuna
                    codigo_vendedor
                    nombre_vendedor
                    ubicacion
                    nombre_cliente
                    nombre_sucursal
                    activo
                    tipo_dte_codigo
                    numero_documento
                    cliente_proveedor_rut
                    grupo_maquina_codigo
                    observacion
                    tipo_destinatario_codigo
                    proveedor_rut
                    proveedor_nombre
                    cliente_proveedor_rut
                    cerrado
                    tipo_garantia_codigo
                    nro_documento_garantia
                    fecha_garantia
                    numero_contrato
                    fecha_contrato
                    fecha_vigencia_contrato
                    fecha_termino_contrato
                    fecha_entrega
                    codigo_rubro
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.obtenerSegunFiltroMaquina;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroMaquinaExcelPdf(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquinaTOmaquinaInputType, $estado: [Decimal], $familia: [Decimal], $vendedor: [Decimal], $proveedor: [Decimal]) {
            maquina {
              obtenerSegunFiltroMaquina(filtro: $filtro, estado: $estado, familia: $familia, vendedor: $vendedor, proveedor: $proveedor) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.obtenerSegunFiltroMaquina;
            callback({ mensajes, respuesta });
        });
    }
    dardeBajaMaquina(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: maquinaInputType) {
            maquina {
              darDeBaja(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  empresa_rut
                  numero_documento
                  tipo_dte_codigo
                  tipo_destinatario_codigo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.darDeBaja;
            callback({ mensajes, respuesta });
        });
    }
    guardar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: maquinaInputType) {
            maquina {
              modificar(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  empresa_rut
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.modificar;
            callback({ mensajes, respuesta });
        });
    }
    EditarMaquina(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: maquinaInputType) {
            maquina {
              modificarMaq(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  empresa_rut
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.modificarMaq;
            callback({ mensajes, respuesta });
        });
    }
    agregar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: maquinaInputType) {
            maquina {
              agregar(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  empresa_rut
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.agregar;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroReporteUbicacion(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquinaTOmaquinaInputType, $estado: [Decimal], $ubicacion: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            maquina {
              obtenerSegunFiltroReporteUbicacion(filtro: $filtro, estado: $estado, ubicacion: $ubicacion, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    ubicacion
                    estado_maquina_nombre
                    conteo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.obtenerSegunFiltroReporteUbicacion;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroReporteUbicacionExcelPdf(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquinaTOmaquinaInputType, $estado: [Decimal], $ubicacion: [Decimal]) {
            maquina {
              obtenerSegunFiltroReporteUbicacion(paginaActual: 1, filtro: $filtro, estado: $estado, ubicacion: $ubicacion) {
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.obtenerSegunFiltroReporteUbicacion;
            callback({ mensajes, respuesta });
        });
    }
    eliminar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: maquinaInputType) {
            maquina {
              eliminar(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  empresa_rut
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina.eliminar;
            callback({ mensajes, respuesta });
        });
    }
}
MaquinaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaquinaService_Factory() { return new MaquinaService(i0.ɵɵinject(i1.GraphQLClient), i0.ɵɵinject(i2.Apollo)); }, token: MaquinaService, providedIn: "root" });
